export default __webpack_public_path__ + "static/media/vechicle-detect.5cb33c28.jpg";